import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { AxiosResponse } from "axios";
import { useLocation } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { BiLoaderCircle } from "react-icons/bi";

import {
  useAppDispatch,
  addOpenBets,
  clearExchangeBets,
  exchangeBetOddsChange,
  removeExchangeBet,
  setBettingInprogress,
  setExchangeBetStake,
  fetchCasinoOpenBets,
  fetchOpenBets,
  fetchBalance,
  BinaryBetrequest,
  BsResponse,
  PlaceBetRequest,
  ButtonVariable,
  EventDTO,
  PROVIDER_ID,
  triggerMultiFetchOrders,
  SelectedObj,
  setTriggerOrders,
  showToast,
  ToastDTO,
  RootState,
  useAppSelector,
} from "@hypexone/uicore";
import { isMobile } from "react-device-detect";
import { Delete } from "lucide-react";
import Modal from "../shared/ModalComponent";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa";
import API from "../../../api";
import Button from "../shared/Button/Button";
import StakeSettings from "../user-menu-pages/StakeSettings";

interface BetSlipProps {
  balance: number;
  exposure: number;
  bets: PlaceBetRequest[];
  // oneClickAmount: number;
  // isOneClickEnable: boolean;
  selectedEventType: { id: ""; name: ""; slug: "" };
  fetchBalance: () => void;
  exchangeBetOddsChange: (index: number, odds: number) => void;
  removeExchangeBet: (index: number) => void;
  setExchangeBetStake: (
    index: number,
    amount: number,
    type: "ADD" | "SET"
  ) => void;
  eventData: EventDTO;
  clearExchangeBets: () => void;
  selectedEvent: SelectedObj;
  fetchOpenBets: (eventId: string[] | string, sportId?: string) => void;
  addOpenBets: (openBets) => void;
  buttonVariables: ButtonVariable[];
  bettingInprogress: boolean;
  cancelBetSuccess?: (betId: string) => void;
  setBettingInprogress: (val: boolean) => void;
  fetchCasinoOpenBets: (gType: string, mId: string) => void;
  mobileView?: boolean;
  setBetStartTime?: any;
  setAddNewBet?: any;
  showToast: Function;
}

const BetSlip: React.FC<BetSlipProps> = (props) => {
  const {
    balance,
    exposure,
    bets,
    eventData,
    fetchBalance,
    cancelBetSuccess,
    selectedEventType,
    exchangeBetOddsChange,
    removeExchangeBet,
    setExchangeBetStake,
    clearExchangeBets,
    selectedEvent,
    fetchOpenBets,
    addOpenBets,
    buttonVariables,
    bettingInprogress,
    setBettingInprogress,
    fetchCasinoOpenBets,
    setBetStartTime,
    setAddNewBet,
    showToast,
  } = props;

  const [showSpinner, setShowSpinner] = useState<boolean>(true);
  const jwt = sessionStorage.getItem("jwt_token");
  const location = useLocation();
  const dispatch = useAppDispatch();
  // const [progressCount, setProgressCount] = useState<number>(5);
  // const [
  //   progressCountRefreshInterval,
  //   setProgressCountRefreshInterval,
  // ] = useState<number>(1000);
  const { langData } = useAppSelector((state) => state.cms);
  const [showStakeModal, setShowStakeModal] = useState<boolean>(false);
  /* Slip validation and placement errors show inside the slip, next to the
     stake that caused them, instead of as a site-wide message. */
  const [slipError, setSlipError] = useState<string>("");

  /* Mobile slip: the stake is typed on Sky's on-screen keypad, so it is kept
     as text (to allow "12." mid-entry) and pushed to the store as a number. */
  const [stakeText, setStakeText] = useState<string>("");
  useEffect(() => {
    const amount = bets?.[0]?.amount || 0;
    setStakeText((text) => ((parseFloat(text) || 0) === amount ? text : amount ? String(amount) : ""));
  }, [bets?.[0]?.amount]);

  const pressKey = (index: number, key: string) => {
    setStakeText((text) => {
      let next = text;
      if (key === "back") next = text.slice(0, -1);
      else if (key === ".") next = text.includes(".") ? text : `${text || "0"}.`;
      else if (text.replace(".", "").length < 9) next = text === "0" ? key.replace(/^0+/, "") || "0" : text + key;
      setExchangeBetStake(index, parseFloat(next) || 0, "SET");
      return next;
    });
  };

  /** Sky's −/+ beside the stake: steps of 100, never below zero. */
  const stepStake = (index: number, amount: number, direction: 1 | -1) =>
    setExchangeBetStake(index, Math.max(0, (amount || 0) + direction * 100), "SET");
  const showSlipError = (alert: ToastDTO) => setSlipError(alert?.message ?? "");

  // A changed stake or price makes the last error stale.
  useEffect(() => {
    setSlipError("");
  }, [bets?.[0]?.amount, bets?.[0]?.oddValue, bets?.length]);

  const betPlaceHandler = async () => {
    if (!sessionStorage.getItem("jwt_token")) {
      return showToast({
        type: "error",
        message: langData?.["login_to_place_bet_txt"],
      });
    }

    setSlipError("");

    if (bets[0].amount < 1) {
      return showSlipError({
        type: "error",
        message: langData?.["minimum_stake_required_txt"],
      });
    }

    if (ValidateOdds(bets)) {
      return showSlipError({
        type: "error",
        message: langData?.["wrong_odds_txt"],
      });
    }

    if (+bets[0].oddLimt) {
      switch (bets[0].marketType) {
        case "MO":
          if (bets[0].oddValue > +bets[0].oddLimt) {
            return showSlipError({
              type: "error",
              message:
                langData?.["bet_rate_not_accepted_txt"] + bets[0].oddLimt,
            });
          }
          break;

        case "BM":
          if ((bets[0].oddValue + 100) / 100 > +bets[0].oddLimt) {
            return showSlipError({
              type: "error",
              message:
                langData?.["bet_rate_not_accepted_txt"] + bets[0].oddLimt,
            });
          }
          break;

        case "FANCY":
          if (bets[0].oddValue / 100 + 1 > +bets[0].oddLimt) {
            return showSlipError({
              type: "error",
              message:
                langData?.["bet_rate_not_accepted_txt"] + bets[0].oddLimt,
            });
          }
          break;
      }
    }

    if (
      (bets[0]?.minStake !== 0 && bets[0]?.minStake > bets[0].amount) ||
      (bets[0]?.maxStake !== 0 && bets[0]?.maxStake < bets[0].amount)
    ) {
      return showSlipError({
        type: "error",
        message: `${langData?.["minimum_stake_txt"]} ${bets[0]?.minStake} ${langData?.["maximum_stake_txt"]} ${bets[0]?.maxStake} `,
      });
    }

    if (!bets[0].oddValue) {
      showSlipError({
        type: "error",
        message: langData?.["invalid_odds_txt"],
      });
      return false;
    }

    let binaryPayload: BinaryBetrequest = null;
    let url = "";
    try {
      for (const data of bets) {
        // Cancel Bet for edit unMatched bet
        if (data.betId) {
          setAddNewBet(false);
          // await cancelBetHandler(data);

          const postBody = {
            cancelBets: [{ betId: data.betId, cancelSize: 0 }],
            marketId: data.marketId,
            eventId: data.eventId,
            sportId: data.sportId,
            seriesId: data.seriesId,
            // operatorId: OPERATORID,
            providerId: PROVIDER_ID,
          };

          try {
            const cancelResponse = await API.post(
              `/bs/cancel-sap-bet`,
              postBody,
              {
                headers: {
                  Authorization: sessionStorage.getItem("jwt_token"),
                },
              }
            );

            setShowSpinner(true);
            if (cancelResponse?.data?.status !== "RS_OK") {
              return showSlipError({
                type: "error",
                message: langData?.["cancel_old_bet_failed_txt"],
              });
            } else if (cancelResponse?.data?.status === "RS_OK") {
              cancelBetSuccess(data.betId);
            }
          } catch (err) {
            setShowSpinner(false);
            return showSlipError({
              type: "error",
              message: langData?.["cancel_bet_failed_txt"],
            });
          }
        }

        setBettingInprogress(true);
        switch (data.marketType) {
          case "MO": {
            url = "/place-matchodds-bet";
            break;
          }
          case "BM": {
            url = "/place-bookmaker-bet";
            break;
          }
          case "FANCY": {
            url = "/place-fancy-bet";
            break;
          }
          case "PREMIUM": {
            url = "/place-premium-bet";
            break;
          }
        }
      }

      setAddNewBet(true);
      let response: AxiosResponse<BsResponse>;
      try {
        response = await API.post("/bs" + url, bets[0], {
          headers: {
            Authorization: jwt,
          },
          timeout: 1000 * 20,
        });

        if (binaryPayload !== null) {
          response = await API.post("/binary/single-bet", binaryPayload, {
            headers: {
              Authorization: jwt,
            },
          });
        }
      } catch (e) {
        setShowSpinner(false);
        setBettingInprogress(false);
        return showSlipError({
          type: "error",
          message: e.response?.data?.message
            ? e.response?.data?.message
            : langData?.["general_err_txt"],
        });
      }

      if (response && response?.status === 200) {
        setBetStartTime(new Date());
      } else {
        showSlipError({
          type: "error",
          message: response?.data?.message
            ? response.data.message
            : langData?.["bet_placed_txt"],
        });
      }
    } catch (ex) {
      setBettingInprogress(false);
      setShowSpinner(false);
      if (ex.response) {
        showSlipError({
          type: "error",
          message: langData?.["bet_inprogress"],
        });
      } else {
        showSlipError({
          type: "error",
          message: langData?.["general_err_txt"],
        });
        return false;
      }
    }
  };

  const onChangeOddHandler = (
    index: any,
    data: PlaceBetRequest,
    control: number
  ) => {
    const isKhadoFancy =
      data.marketType === "FANCY" &&
      (data.oddType === "KHADO" ||
        (data.mcategory && data.mcategory.toLowerCase() === "khado"));

    if (data.oddValue === 1) {
      return false;
    }

    let value;
    if (control === 1) {
      let inc;
      if (isKhadoFancy) inc = 1;
      else if (data.oddValue < 2) inc = 0.01;
      else if (data.oddValue >= 2 && data.oddValue < 3) inc = 0.02;
      else if (data.oddValue >= 3 && data.oddValue < 4) inc = 0.05;
      else if (data.oddValue >= 4 && data.oddValue < 6) inc = 0.1;
      else if (data.oddValue >= 6 && data.oddValue < 10) inc = 0.2;
      else if (data.oddValue >= 10 && data.oddValue < 20) inc = 0.5;
      else if (data.oddValue >= 20 && data.oddValue < 30) inc = 1;
      else if (data.oddValue >= 30 && data.oddValue < 50) inc = 2;
      else if (data.oddValue >= 50 && data.oddValue < 100) inc = 5;
      else if (data.oddValue >= 100 && data.oddValue < 1000) inc = 10;
      else inc = 10;
      // value =
      //   data.marketType !== 'FANCY'
      //     ? data.marketType === 'CASINO'
      //       ? data.casinoOdds
      //       : (data.oddValue + inc).toFixed(2)
      //     : data.oddsSize;
      value =
        data.marketType !== "FANCY" || isKhadoFancy
          ? (data.oddValue + inc).toFixed(2)
          : data.oddValue.toFixed(2);
    } else {
      let inc;
      if (isKhadoFancy) inc = 1;
      else if (data.oddValue <= 2) inc = 0.01;
      else if (data.oddValue > 2 && data.oddValue <= 3) inc = 0.02;
      else if (data.oddValue > 3 && data.oddValue <= 4) inc = 0.05;
      else if (data.oddValue > 4 && data.oddValue <= 6) inc = 0.1;
      else if (data.oddValue > 6 && data.oddValue <= 10) inc = 0.2;
      else if (data.oddValue > 10 && data.oddValue <= 20) inc = 0.5;
      else if (data.oddValue > 20 && data.oddValue <= 30) inc = 1;
      else if (data.oddValue > 30 && data.oddValue <= 50) inc = 2;
      else if (data.oddValue > 50 && data.oddValue <= 100) inc = 5;
      else if (data.oddValue > 100 && data.oddValue <= 1000) inc = 10;
      else inc = 10;
      // value =
      //   data.marketType !== 'FANCY'
      //     ? data.marketType === 'CASINO'
      //       ? data.casinoOdds
      //       : (data.oddValue - inc).toFixed(2)
      //     : data.oddsSize;
      value =
        data.marketType !== "FANCY" || isKhadoFancy
          ? (data.oddValue - inc).toFixed(2)
          : data.oddValue.toFixed(2);
    }

    exchangeBetOddsChange(index, parseFloat(value.toString()));
  };

  const ValidateOdds = (bets: PlaceBetRequest[]) => {
    const matchOdds = eventData?.matchOdds?.runners;

    // Match Odds odd check
    if (matchOdds) {
      for (let bet of bets) {
        if (
          bet?.marketType === "MO" &&
          bet?.marketId === eventData?.matchOdds?.marketId
        ) {
          for (let mo of matchOdds) {
            if (mo.runnerId === bet.outcomeId) {
              if (bet.betType === "BACK") {
                if (mo?.backPrices) {
                  if (bet.oddValue <= mo.backPrices[0]?.price) {
                    return false;
                  } else {
                    return true;
                  }
                }
              } else {
                if (mo?.layPrices) {
                  console.log(mo.layPrices[0].price, "<=", bet.oddValue);
                  if (mo.layPrices[0]?.price <= bet.oddValue) {
                    return false;
                  } else {
                    return true;
                  }
                }
              }
            }
          }
        }
      }
    }
  };

  return (
    <>
      {bets?.length > 0 &&
        bets?.map((bet, index) => {
          const isBack = bet?.betType === "BACK";
          // Odds can be nudged on match odds and khado fancies only, as before.
          const oddsAdjustable =
            bet.marketType === "MO" ||
            (bet.marketType === "FANCY" &&
              (bet.oddType === "KHADO" || bet.mcategory?.toLowerCase() === "khado"));
          const oddsShown = bet?.displayOddValue ? bet?.displayOddValue : bet?.oddValue;
          // A normal fancy is "run over rate" in Sky's odds box (27 / 100);
          // its bet carries the run as sessionPrice and the rate as oddValue.
          const isRunRateFancy = bet.marketType === "FANCY" && !oddsAdjustable && bet?.sessionPrice != null;
          const canPlace = Boolean(bet?.amount) && !bettingInprogress;

          if (isMobile) {
            // Sky's mobile slip: odds + stake steppers, a dark quick-stake bar,
            // an on-screen keypad, then big Cancel / Place Bet buttons.
            const stepper =
              "flex h-[42px] items-stretch overflow-hidden rounded-[4px] border border-[#aaa] bg-white";
            const stepButton =
              "flex w-[44px] shrink-0 items-center justify-center bg-sky-btn-gradient text-[24px] leading-none text-[#1f72ac]";
            return (
              <div
                key={index}
                className={`relative ${isBack ? "bg-slipBack" : "bg-slipLay"} border-y ${
                  isBack ? "border-slipBackBorder" : "border-slipLayBorder"
                } ${bettingInprogress ? "opacity-75" : ""}`}
              >
                <div className="px-3 pb-3 pt-2">
                  <div className="mb-1 grid grid-cols-2 gap-3 text-[12px] text-[#1e1e1e]">
                    <span className="font-bold">
                      {bet?.oddType === "ODD_EVEN" || bet?.marketName?.includes("Odd Even Run Bhav")
                        ? bet?.outcomeDesc
                        : ""}
                    </span>
                    <span className="text-center">
                      Min Bet: <b>{bet?.minStake ?? 0}</b>
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    {oddsAdjustable ? (
                      <div className={stepper}>
                        <button
                          type="button"
                          className={stepButton}
                          disabled={bettingInprogress}
                          onClick={() => onChangeOddHandler(index, bet, 0)}
                          aria-label="Lower odds"
                        >
                          −
                        </button>
                        <span className="flex flex-1 items-center justify-center text-[16px] font-bold text-[#1e1e1e]">
                          {oddsShown}
                        </span>
                        <button
                          type="button"
                          className={stepButton}
                          disabled={bettingInprogress}
                          onClick={() => onChangeOddHandler(index, bet, 1)}
                          aria-label="Raise odds"
                        >
                          +
                        </button>
                      </div>
                    ) : (
                      <div className="flex h-[42px] items-center justify-center rounded-[4px] border border-[#bbb] bg-[#dcdcdc] text-[16px] font-bold text-[#999]">
                        {isRunRateFancy ? `${bet.sessionPrice} / ${bet.oddValue}` : oddsShown}
                      </div>
                    )}
                    <div className={stepper}>
                      <button
                        type="button"
                        className={stepButton}
                        disabled={bettingInprogress}
                        onClick={() => stepStake(index, bet?.amount, -1)}
                        aria-label="Lower stake"
                      >
                        −
                      </button>
                      <span
                        className="flex flex-1 items-center justify-center bg-[#faf0cf] text-[16px] font-bold text-[#1e1e1e]"
                        aria-label="Stake"
                      >
                        {stakeText || <span className="h-[20px] w-[2px] animate-pulse bg-[#1f72ac]" />}
                      </span>
                      <button
                        type="button"
                        className={stepButton}
                        disabled={bettingInprogress}
                        onClick={() => stepStake(index, bet?.amount, 1)}
                        aria-label="Raise stake"
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>

                {slipError ? (
                  <div role="alert" className="px-3 pb-2">
                    <div className="rounded border border-[#d0021b]/40 bg-[#fdf0ef] px-2 py-1 text-xs font-bold text-[#d0021b]">
                      {slipError}
                    </div>
                  </div>
                ) : null}

                <div className="grid grid-cols-6 bg-sky-panel-head text-white">
                  {buttonVariables.slice(0, 6).map((button, btnIndex) => (
                    <button
                      key={btnIndex}
                      type="button"
                      onClick={() => setExchangeBetStake(index, button.stake, "ADD")}
                      className={`py-[11px] text-[13px] ${btnIndex ? "border-l border-white/20" : ""}`}
                    >
                      {Number(button.stake).toLocaleString("en-US")}
                    </button>
                  ))}
                </div>

                <div className="grid grid-cols-7 bg-white text-[17px] text-[#1e1e1e]">
                  {["1", "2", "3", "4", "5", "6"].map((key) => (
                    <button key={key} type="button" onClick={() => pressKey(index, key)} className="h-[40px] border-b border-r border-[#ccc]">
                      {key}
                    </button>
                  ))}
                  <button
                    type="button"
                    onClick={() => pressKey(index, "back")}
                    className="row-span-2 flex items-center justify-center border-b border-[#ccc]"
                    aria-label="Delete"
                  >
                    <Delete className="h-6 w-6" />
                  </button>
                  {["7", "8", "9", "0", "00", "."].map((key) => (
                    <button key={key} type="button" onClick={() => pressKey(index, key)} className="h-[40px] border-b border-r border-[#ccc]">
                      {key}
                    </button>
                  ))}
                </div>

                <div className="grid grid-cols-2 gap-3 px-3 py-3">
                  <button
                    type="button"
                    onClick={() => removeExchangeBet(index)}
                    className="h-[44px] rounded-[6px] border border-[#999] bg-sky-btn-gradient text-[16px] font-bold text-[#1e1e1e]"
                  >
                    {langData?.["cancel"] ?? "Cancel"}
                  </button>
                  <button
                    type="button"
                    disabled={!canPlace}
                    onClick={betPlaceHandler}
                    className={`h-[44px] rounded-[6px] border text-[16px] font-bold ${
                      canPlace
                        ? "border-[#222] bg-sky-send-gradient text-skySendText"
                        : "border-[#d9d2d4] bg-[#e8e3e5] text-[#c9c2c4]"
                    }`}
                  >
                    {langData?.["place_bet_txt"] ?? "Place Bet"}
                  </button>
                </div>

                {bettingInprogress ? (
                  <BiLoaderCircle className="absolute inset-0 m-auto h-8 w-8 animate-spin opacity-75" />
                ) : null}
              </div>
            );
          }

          return (
            // Sky's inline bet slip: one row of controls on the slip colour,
            // then a lighter row of quick stakes.
            <div key={index} className={`relative ${bettingInprogress ? "opacity-75" : ""}`}>
              {bettingInprogress && !isMobile && (
                <BiLoaderCircle className="animate-spin absolute inset-0 m-auto h-8 w-8 opacity-75" />
              )}

              <div
                className={`${
                  isBack ? "bg-slipBack border-slipBackBorder" : "bg-slipLay border-slipLayBorder"
                } border-t border-[#7e97a7] shadow-[inset_0_2px_0_rgba(0,0,0,0.1)] flex flex-wrap items-center gap-[5px] pl-[7px] pr-[5px] py-[7px] text-[12px] leading-[15px]`}
              >
                <div className="min-w-0 flex-1 text-[12px] font-bold text-[#1e1e1e] max-md:basis-full">
                  {bet?.marketName}
                  {bet?.oddType === "ODD_EVEN" || bet?.marketName?.includes("Odd Even Run Bhav")
                    ? ` - ${bet?.outcomeDesc}`
                    : ""}
                </div>

                <div className="flex items-center gap-[5px] max-md:w-full">
                  <Button
                    onClick={() => removeExchangeBet(index)}
                    className="h-[33px] w-[100px] shrink-0 rounded-[4px] bg-sky-btn-gradient border border-[#bbb] text-[12px] font-bold text-[#1e1e1e] max-md:flex-1"
                  >
                    {langData?.["cancel"] ?? "Cancel"}
                  </Button>

                  <div
                    className={`flex h-[33px] w-[94px] shrink-0 items-center rounded-[4px] ${
                      isBack ? "bg-slipBackOdds" : "bg-slipLayOdds"
                    } max-md:flex-1`}
                  >
                    {oddsAdjustable ? (
                      <Button
                        onClick={() => onChangeOddHandler(index, bet, 0)}
                        disabled={bettingInprogress}
                        className="flex h-full w-[26px] items-center justify-center"
                        aria-label="Lower odds"
                      >
                        <FaMinus size={10} color="#1e1e1e" />
                      </Button>
                    ) : null}
                    <span className="flex flex-1 flex-col items-end px-[6px] text-[12px] font-bold leading-[13px] text-[#1e1e1e]">
                      {isRunRateFancy ? (
                        <>
                          <span>{bet.sessionPrice}</span>
                          <span className="text-[11px] font-normal">{bet.oddValue}</span>
                        </>
                      ) : (
                        oddsShown
                      )}
                    </span>
                    {oddsAdjustable ? (
                      <Button
                        onClick={() => onChangeOddHandler(index, bet, 1)}
                        disabled={bettingInprogress}
                        className="flex h-full w-[26px] items-center justify-center"
                        aria-label="Raise odds"
                      >
                        <FaPlus size={10} color="#1e1e1e" />
                      </Button>
                    ) : null}
                  </div>

                  <NumericFormat
                    className="h-[33px] w-[114px] shrink-0 rounded-[4px] border-0 shadow-[inset_0_1px_0_rgba(0,0,0,0.5)] bg-white px-[5px] text-right text-[12px] font-bold text-[#1e1e1e] focus:outline-none focus:border-slipFocus focus:shadow-[0_0_4px_2px_rgba(31,114,172,0.7)] max-md:flex-1 max-md:w-0"
                    value={bet?.amount}
                    thousandSeparator={true}
                    thousandsGroupStyle="lakh"
                    allowNegative={false}
                    disabled={bettingInprogress}
                    aria-label="Stake"
                    onValueChange={(val) => {
                      setExchangeBetStake(index, val.floatValue, "SET");
                    }}
                  />

                  <Button
                    className={`h-[33px] w-[200px] shrink-0 rounded-[4px] border border-[#222] bg-sky-send-gradient text-[12px] font-bold text-skySendText max-md:flex-1 ${
                      canPlace ? "" : "opacity-50"
                    }`}
                    disabled={!canPlace}
                    onClick={betPlaceHandler}
                  >
                    {langData?.["place_bet_txt"] ?? "Place Bets"}
                  </Button>
                </div>
              </div>

              {slipError ? (
                <div
                  role="alert"
                  className={`${isBack ? "bg-slipBack" : "bg-slipLay"} px-2 pb-2`}
                >
                  <div className="rounded border border-[#d0021b]/40 bg-[#fdf0ef] px-2 py-1 text-xs font-bold text-[#d0021b]">
                    {slipError}
                  </div>
                </div>
              ) : null}

              <div
                className={`${
                  isBack ? "bg-slipBackRow border-slipBackBorder" : "bg-slipLayRow border-slipLayBorder"
                } border-y flex flex-wrap items-center justify-end gap-[5px] pl-[7px] pr-[5px] py-[5px]`}
              >
                <Button
                  onClick={() => setShowStakeModal(true)}
                  className="mr-auto h-[25px] rounded-[4px] border border-slipInputBorder bg-white px-[8px] text-[12px] font-bold text-black shadow-[inset_0_1px_0_0_rgba(255,255,255,0.8)] hover:underline"
                >
                  {langData?.["edit_stake"] ?? "Edit Stakes"}
                </Button>
                {buttonVariables.slice(0, 6).map((button, btnIndex) => (
                  <Button
                    key={btnIndex}
                    onClick={() => setExchangeBetStake(index, button.stake, "ADD")}
                    className="h-[25px] w-[calc((70%-25px)/6)] min-w-[64px] rounded-[4px] border border-[#bbb] bg-sky-btn-gradient px-[4px] text-[12px] leading-[23px] text-[#1e1e1e] max-md:w-auto max-md:min-w-0 max-md:flex-[1_1_30%]"
                  >
                    {button.label}
                  </Button>
                ))}
              </div>
            </div>
          );
        })}
      {showStakeModal && (
        <Modal
          isOpen={showStakeModal}
          onClose={() => setShowStakeModal(false)}
          title={langData?.["edit_stake"] ?? "Edit Stake"}
          isContentWidth
        >
          <StakeSettings />
        </Modal>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    bets: state.betSlip.bets,
    selectedEvent: state.catalog.selectedEvent,
    selectedEventType: state.catalog.selectedEventType,
    buttonVariables: state.betSlip.buttonVariables,
    bettingInprogress: state.betSlip.bettingInprogress,
    oneClickAmount: state.betSlip.oneClickAmount,
    isOneClickEnable: state.betSlip.isOneClickEnable,
    balance: state.auth.balanceSummary.balance,
    exposure: state.auth.balanceSummary.exposure,
    openBets: state.betSlip.openBets,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchBalance: () => dispatch(fetchBalance()),
    // cancelBetSuccess: (betId: string) => dispatch(cancelBetSuccess(betId)),
    exchangeBetOddsChange: (index: number, odds: number) =>
      dispatch(exchangeBetOddsChange({ index, odds })),
    removeExchangeBet: (index: number) => dispatch(removeExchangeBet(index)),
    setExchangeBetStake: (index: number, amount: number, type: "ADD" | "SET") =>
      dispatch(setExchangeBetStake({ index, amount, type })),
    fetchOpenBets: (eventId: string | string[], sportId?: string) =>
      dispatch(fetchOpenBets({ eventId, sportId })),
    addOpenBets: (openBets) => dispatch(addOpenBets(openBets)),
    setBettingInprogress: (val: boolean) => dispatch(setBettingInprogress(val)),
    fetchCasinoOpenBets: (gameType: string, mId: string) =>
      dispatch(fetchCasinoOpenBets({ gameType, mId })),
    showToast: (alert: ToastDTO) => dispatch(showToast(alert)),
    triggerMultiFetchOrders: (eventId: string) =>
      dispatch(triggerMultiFetchOrders(eventId)),
    setTriggerOrders: () => dispatch(setTriggerOrders()),
    clearExchangeBets: () => clearExchangeBets(),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BetSlip);
